/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileAttachmentDto } from './FileAttachmentDto';
import {
    FileAttachmentDtoFromJSON,
    FileAttachmentDtoFromJSONTyped,
    FileAttachmentDtoToJSON,
    FileAttachmentDtoToJSONTyped,
} from './FileAttachmentDto';

/**
 * 
 * @export
 * @interface GenerateInstructionDto
 */
export interface GenerateInstructionDto {
    /**
     * Patient ID (required - for associating instruction with a patient)
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    patientId: string;
    /**
     * Treatment plan ID (required - for associating instruction with a treatment plan)
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    treatmentPlanId?: string;
    /**
     * Language of the instruction
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    language: string;
    /**
     * Patient comments
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    patientComments?: string;
    /**
     * Additional comments
     * @type {string}
     * @memberof GenerateInstructionDto
     */
    additionalComments?: string;
    /**
     * Files to attach and include as context when generating this instruction (images, PDF, DOCX)
     * @type {Array<FileAttachmentDto>}
     * @memberof GenerateInstructionDto
     */
    attachments?: Array<FileAttachmentDto>;
}

/**
 * Check if a given object implements the GenerateInstructionDto interface.
 */
export function instanceOfGenerateInstructionDto(value: object): value is GenerateInstructionDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function GenerateInstructionDtoFromJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoFromJSONTyped(json, false);
}

export function GenerateInstructionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateInstructionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'treatmentPlanId': json['treatmentPlanId'] == null ? undefined : json['treatmentPlanId'],
        'language': json['language'],
        'patientComments': json['patientComments'] == null ? undefined : json['patientComments'],
        'additionalComments': json['additionalComments'] == null ? undefined : json['additionalComments'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileAttachmentDtoFromJSON)),
    };
}

export function GenerateInstructionDtoToJSON(json: any): GenerateInstructionDto {
    return GenerateInstructionDtoToJSONTyped(json, false);
}

export function GenerateInstructionDtoToJSONTyped(value?: GenerateInstructionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'treatmentPlanId': value['treatmentPlanId'],
        'language': value['language'],
        'patientComments': value['patientComments'],
        'additionalComments': value['additionalComments'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileAttachmentDtoToJSON)),
    };
}

